import { common } from "./common.js";
import { rules } from "./rules.js";
import { terms } from "./terms.js";

export const sw = {
	translation: {
		...common,
		...rules,
		...terms,
	},
};
